import type { API } from 'chessboard/api/config/types';
import { calculateTimestampValue } from 'chessboard/model/move/calculate-timestamp-value';
import { setClkOnNode } from 'chessboard/model/move/set-clk-on-node';
import { setTimestampOnNode } from 'chessboard/model/move/set-timestamp-on-node';

/**
 * Handle the time value coming from a move node
 */
export function handleTimestamp({ context, time }: { context: API.Context; time: number }) {
  const { api, game } = context;
  const node = game.moveDetails();

  node.time = time;

  setClkOnNode({ api, node, clk: time });

  const timestamp = calculateTimestampValue({ api, node });

  if (timestamp) {
    setTimestampOnNode({ api, node, timestamp });
  }
}
